function initWindowEvents() {
  window.onfocus = checkLocalStorageForActiveOAuth;
  window.onload = checkLocalStorageForActiveOAuth;
  window.onblur = setSessionOAuthToLocalStorage;
}

// remove local storage item that may be leftover from previous session
window.localStorage.removeItem('SIGN_OUT_ALL_USERS');

function checkLocalStorageForActiveOAuth() {
  const SIGN_OUT_ALL_USERS = window.localStorage.getItem('SIGN_OUT_ALL_USERS');
  if (SIGN_OUT_ALL_USERS) {
    localStorage.clear();
    sessionStorage.clear();
    window.localStorage.setItem('SIGN_OUT_ALL_USERS', true);
    return;
  } 

  const oauth = window.sessionStorage.getItem('oauth');
  if (!oauth) {
    const localStoreAuth = window.localStorage.getItem('oauth', oauth);
    if (localStoreAuth) window.sessionStorage.setItem('oauth', localStoreAuth);
  }
}

function setSessionOAuthToLocalStorage() {
  const oauth = window.sessionStorage.getItem('oauth');
  if (oauth) {
    window.localStorage.setItem('oauth', oauth);
  }
}

initWindowEvents();

require('angular-cookies');
require('./third_party/ui-router/angular-ui-router.js');
require('angular-messages');
require('angular-google-analytics');
require('angular-translate');
require('./third_party/angular-scroll/angular-scroll.js');
require('./third_party/angular-moment/angular-moment');
require('./third_party/ng-ui-select/select');
require('./third_party/angular-pickadate/angular-pickadate.js');
require('./third_party/angular-addtocalendar/addtocalendar.js');
require('./third_party/ng-idle/angular-idle.js');
require('./third_party/angular-sanitize/angular-sanitize.js');
require('./third_party/legacy/angular-fancy-modal-0.1.4/angular-fancy-modal');
require('./directives/lbTooltip');

require(`./globalStyles/app.${process.env.APP_INITIAL}.scss`);

const app = angular.module('app', [
  'ngCookies',
  'duScroll',
  'ngMessages',
  'ui.router',
  'angular-google-analytics',
  'angularMoment',
  'ui.select',
  'vesparny.fancyModal',
  require('./components/lbResolveLoader/lbResolveLoader').name,
  require('./components/lbDialog').name,
  require('./components/lbLoadingPlaceholder').name,
  require('./components/lbTimeSelect').name,
  require('./components/lbCountrySelect').name,
  require('./components/lbDateSelect').name,
  require('./components/lbDatePicker/lbDatePicker').name,
  require('./components/lbPoiSelect').name,
  require('./components/lbFiveStarRating').name,
  require('./components/lbModal').name,
  require('./components/lbErrorModal/lbErrorModal').name,
  require('./components/lbTimeoutModal/lbTimeoutModal').name,
  require('./components/lbFareRulesModal/lbFareRulesModal').name,
  require('./components/lbTripOptionsModal').name,
  require('./components/lbCarHandlingModal').name,
  require('./components/lbCurrencyMessage/lbCurrencyMessage').name,
  require('./components/lbSearchResultsProgress/lbSearchResultsProgress').name,
  require('./components/lbToggle').name,
  require('./components/lbCardIcon/lbCardIcon').name,
  require(`./appSpecificImports/index.${process.env.APP_INITIAL}`).name,
  'pascalprecht.translate',
  'ngSanitize',
  'app.lbTooltip',
  'ngIdle',
  'ngPatternRestrict'
]);

app.directive('lbSequentialTime', require('./directives/lbSequentialTime'));
app.directive('lbFutureTime', require('./directives/lbFutureTime'));
app.directive('focusOn', require('./directives/focusOn'));
app.directive('inputMatch', require('./directives/inputMatch'));
app.directive('clickOutside', require('./directives/lbClickOutside'));

app.config(['$compileProvider', '$locationProvider', function($compileProvider, $locationProvider) {
  $compileProvider.preAssignBindingsEnabled(true);
  $locationProvider.hashPrefix('');
}]);

app.config(['uiSelectConfig', function (uiSelectConfig) {
  uiSelectConfig.theme = 'selectize';
}]);

app.config(['$translateProvider', function ($translateProvider) {
  const Lang = window.sessionStorage.getItem('i18nCode') || 'en-AU';
  $translateProvider
    .useSanitizeValueStrategy('sanitize')
    .translations('en-AU', require('!json!./locals/en-AU.json'))
    .translations('en-US', require('!json!./locals/en-US.json'))
    .translations('en-GB', require('!json!./locals/en-GB.json'))
    .fallbackLanguage(['en-AU', 'en-US', 'en-GB'])
    .preferredLanguage(Lang);
}]);

app.config(['$compileProvider', function ($compileProvider) {
  $compileProvider.debugInfoEnabled(false);
}]);

app.config(['IdleProvider', function (IdleProvider) {
  IdleProvider.autoResume('notIdle');
  IdleProvider.idle(60 * 20);
  IdleProvider.timeout(30);
}]);

app.constant('APP_CONFIG', require('./config/appConfig'));
app.constant('AUTH_EVENTS', require('./constants/authConstants'));
app.constant('ENUMS', require('./constants/enums'));

app.filter('sectorGroupsFilter', require('./filters/sectorGroupsFilter'));
app.filter('creditCardNumberFilter', require('./filters/creditCardNumberFilter'));
app.filter('startCaseFilter', require('./filters/stringFilters').startCaseFilter);
app.filter('paddingFilter', require('./filters/paddingFilter'));
app.filter('noValueFilter', require('./filters/noValueFilter'));
app.filter('cssClassNameFilter', require('./filters/cssClassNameFilter'));
app.filter('genericSortingFilter', require('./filters/genericSortingFilter'));
app.filter('locationIconFilter', require('./filters/locationIconFilter'));
app.filter('distanceFilter', require('./filters/distanceFilter'));
app.filter('secondsToTimeFilter', require('./filters/secondsToTimeFilter'));
app.filter('cssClassNameFilter', require('./filters/cssClassNameFilter'));
app.filter('toAddressFilter', require('./filters/toAddressFilter'));
app.filter('keyToLabelFilter', require('./filters/keyToLabelFilter'));
app.filter('ancillaryServicesAmountsFilter', require('./filters/ancillaryServicesAmountsFilter'));
app.filter('hotelProviderBrandFilter', require('./filters/hotelProviderBrandFilter'));
app.filter('deepCopyFilter', require('./filters/deepCopyFilter'));
app.filter('checkinInfoFilter', require('./filters/checkinInfoFilter'));
app.filter('priceWithOperatorFilter', require('./filters/priceWithOperatorFilter'));

app.config(require(`./routes/routes.base`)(app));
app.config(require(`./routes/routes.${process.env.APP_INITIAL}`)(app));

app.config(require('./config/httpProviderConfig')(app));
app.config(require('./config/gaConfig')(app));

app.factory('requestInterceptor', require('./factories/requestInterceptor'));
app.factory('$exceptionHandler', require('./factories/exceptionHandler'));

app.service('apiService', require('./services/apiService'));
app.service('appInsightsService', require('./services/appInsightsService'));
app.service('authService', require('./services/authService'));
app.service('currentUserService', require('./services/currentUserService'));
app.service('itinerariesService', require('./services/itinerariesService'));
app.service('travellersService', require('./services/travellersService'));
app.service('settingsService', require('./services/settingsService'));
app.service('userInfoService', require('./services/userInfoService'));
app.service('travelService', require('./services/travelService'));
app.service('travelFiltersService', require('./services/travelFiltersService'));
app.service('flailService', require('./services/flailService'));
app.service('changeCartService', require('./services/changeCartService'));
app.service('cartService', require('./services/cartService'));
app.service('carSearchService', require('./services/carSearchService'));
app.service('sectorService', require('./services/sectorService'));
app.service('searchFormService', require('./services/searchFormService'));
app.service('iataSearchService', require('./services/iataSearchService'));
app.service('departmentService', require('./services/departmentService'));
app.service('locationsSearchService', require('./services/locationsSearchService'));
app.service('depotSearchService', require('./services/depotSearchService'));
app.service('citySearchService', require('./services/citySearchService'));
app.service('locationService', require('./services/locationService'));
app.service('toggleService', require('./services/toggleService'));
app.service('stateResolveService', require('./services/stateResolveService'));
app.service('seatMapService', require('./services/seatMapService'));
app.service('seatNumberService', require('./services/seatNumberService'));
app.service('cdnService', require('./services/cdnService'));
app.service('unusedTicketsService', require('./services/unusedTicketsService'));
app.service('breakPolicyService', require('./services/breakPolicyService'));
app.service('timesService', require('./services/timesService'));
app.service('userProfileService', require('./services/userProfileService'));
app.service('userDebtorService', require('./services/userDebtorService'));
app.service('guestTravellerService', require('./services/guestTravellerService'));
app.service('paymentMethodsService', require('./services/paymentMethodsService'));
app.service('duplicateBookingsService', require('./services/duplicateBookingsService'));
app.service('searchResultsLoaderService', require('./components/lbSearchResultsLoader/searchResultsLoaderService'));
app.service('ndcExpiredService', require('./services/ndcExpiredService'));
app.service('lbHotelSearchService', require('./services/lbHotelSearchService'));


app.run(['Analytics', Analytics => {
  // This gets analytics started, must have reference to Analytics
  window.svelteStore.trackingInit(); //mixpanel init
}]);

app.run(['$rootScope', '$location', ($rootScope, $location) => {
  $rootScope.enableDebug = $location.search().enabledebug;
}]);

app.run(['$rootScope', ($rootScope) => {
  $rootScope.$on('openDatePicker', (event, settings) => {
    $rootScope.datePickerSettings = settings;
    $rootScope.showDatePicker = true;
  });

  $rootScope.$on('closeDatePicker', () => {
    $rootScope.datePickerSettings = undefined;
    $rootScope.showDatePicker = false;
  });
}]);

app.run(['$rootScope', '$injector', ($rootScope, $injector) => {
  $rootScope.$on('$stateChangeSuccess', function () {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  });

  // SEE /vendor/angular.src.js line 4843
  app.register = $injector.loadModule.bind($injector);  
}]);

app.run(['$rootScope', '$window', '$timeout', 'lbModalService', 'authService', 'AUTH_EVENTS', function ($rootScope, $window, $timeout, lbModalService, authService, AUTH_EVENTS) {
  $rootScope.$on('IdleStart', function () {
    $timeout(function () {
      lbModalService.open(
        '<lb-timeout-modal></lb-timeout-modal>'
      );
    });
  });

  $rootScope.$on('IdleTimeout', function () {
    window.svelteStore.track(window.svelteStore.trackingEvents.TIMED_OUT);
    
    authService.logout().then(function () {
      lbModalService.resolve();
      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);  
    });
  });
}]);

app.run(['$rootScope', '$state', '$q', '$urlRouter', '$fancyModal', '$injector', '$cookies', 'authService', 'currentUserService', 'itinerariesService', 'locationService', 'settingsService', 'userInfoService', ($rootScope, $state, $q, $urlRouter, $fancyModal, $injector, $cookies, authService, currentUserService, itinerariesService, locationService, settingsService, userInfoService) =>
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    $fancyModal.close();
    $rootScope.showLoader = !!toState.resolve;
    toState.resolve = toState.resolve || {};
    userInfoService.userInfoRequired = toParams.userInfoRequired;
    settingsService.settingsRequired = toParams.settingsRequired;
    settingsService.allowNoSettingsForConsultant = toParams.allowNoSettingsForConsultant;

    function loadSettings() {
      if (toParams.isPublic || settingsService.settingsLoading || settingsService.settings) return;

      if (toParams.settingsRequired && (currentUserService.get('debtor') || !(toParams.allowNoSettingsForConsultant && currentUserService.isConsultant()))) {
        settingsService.getAny().then(function() {
          $rootScope.$broadcast('loadSettingsComplete');
        });
      } else {
        $rootScope.$broadcast('loadSettingsComplete');
      }
    }

    if ($cookies.get('LIGHTNINGBOOK_API_ACCESSTOKEN')) localStorage.removeItem('SIGN_OUT_ALL_USERS');

    if (!authService.isAuthenticated()) {
      app.previousSate = {
        toState,
        toParams
      };

      if (!toParams.isPublic) {
        $rootScope.showLoader = false;
        event.preventDefault();
        $state.go('landing.login');
        return;
      }
    }

    if (toState.redirectTo) {
      event.preventDefault();
      $state.go(toState.redirectTo, toParams);
      return;
    }

    if (toParams.userInfoRequired) {
      if(!currentUserService.get('userInfo')) {
        userInfoService.getInfo().then(function() {
          $rootScope.$broadcast('loadUserInfoComplete');
          loadSettings();
        });
      } else {
        $rootScope.$broadcast('loadUserInfoComplete');
        loadSettings();
      }
    } else {
      $rootScope.$broadcast('loadUserInfoComplete');
      loadSettings();
    }

    if (toParams.searchRequired) {
      toState.resolve.itinerary = ['$q', function ($q) {
        const defer = $q.defer();

        if (!itinerariesService.itinerary) {
          itinerariesService.get().then(() => {
            changeState()
          }, () => {
            $rootScope.showLoader = false;
            defer.reject();
          });
        } else {
          changeState()
        }

        function changeState() {
          let hasSearch = false;

          switch (toState.name) {
            case 'app.booking.flights':
              hasSearch = !!itinerariesService.itinerary.Search.Flights[locationService.searchIndex.Flight];
              break;

            case 'app.booking.rail':
              hasSearch = !!itinerariesService.itinerary.Search.Rails[locationService.searchIndex.Rail];
              break;

            case 'app.booking.hotels':
              hasSearch = !!itinerariesService.itinerary.Search.Hotels[locationService.searchIndex.Hotel];
              break;

            case 'app.booking.cars':
              hasSearch = !!itinerariesService.itinerary.Search.Cars[locationService.searchIndex.Car];
              break;

            default:
              hasSearch = true;
              break;
          }

          if (hasSearch) {
            defer.resolve();
          } else {
            $rootScope.showLoader = false;
            defer.reject();
          }
        }

        return defer.promise;
      }];
    }
  })
]);

app.run(['$rootScope', '$state', '$window', 'Analytics', 'Idle', 'authService', 'appInsightsService', 'APP_CONFIG', ($rootScope, $state, $window, Analytics, Idle, authService, appInsightsService, APP_CONFIG) =>
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    const pagePath = ($state.href(toState.name, toParams) || '').substr(1);
    const pageTitle = APP_CONFIG.APP_NAME + (toState.params && toState.params.pageTitle ? ` - ${toState.params.pageTitle}` : '');

    $rootScope.showLoader = false;

    $rootScope.bodyClass = toParams.bodyClass || 'bg';
    $rootScope.pageTitle = pageTitle;

    if (APP_CONFIG.analytics.enabled) {
      Analytics.set('page', pagePath);
      Analytics.trackPage(pagePath, $rootScope.pageTitle);
    }

    if (APP_CONFIG.appInsights.enabled) {
      appInsightsService.trackPageView(pagePath);
    }

    window.svelteStore.track('PAGE_VIEW', {
      path: pagePath,
      title: (toState && toState.params && toState.params.pageTitle) || ''
    });

    if (authService.isAuthenticated()) {
      if (!Idle.running()) {
        Idle.watch();
      }
    } else {
      Idle.unwatch();
    }
  })
]);

app.run(['$rootScope', '$state', 'AUTH_EVENTS', ($rootScope, $state, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
    
    localStorage.removeItem('SIGN_OUT_ALL_USERS');

    if (app.previousSate && !app.previousSate.toParams.isPublic) {
      $state.go(app.previousSate.toState, app.previousSate.toParams);
    } else {
      $state.go('app.home.search');
    }
  })
]);

app.run(['$rootScope', '$state', 'AUTH_EVENTS', ($rootScope, $state, AUTH_EVENTS) => {
  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    $state.go('landing.login', {}, {reload: true});
  })
}]);

app.run(['$rootScope', '$state', 'lbModalService', ($rootScope, $state, lbModalService) =>
  $rootScope.$on('httpError', function (event, data, onClose) {
      onClose = onClose || _.noop;
      lbModalService.open('<lb-error-modal></lb-error-modal>', {}, data).then(onClose);
  })
]);

app.run(['$rootScope', '$state', ($rootScope, $state) => {
  $rootScope.$on('$stateChangeError', () => {
    if ($state.is('authenticate')) {
      $state.go('landing.login');
    } else {
      $state.go('app.home.search');
    }

    $rootScope.showLoader = false;
  });

  $rootScope.$on('404Error', () => {
    $rootScope.showLoader = false;
    $state.transitionTo('app.error');
  });


}]);

export default app;



// WEBPACK FOOTER //
// ./src/app.js